import commonservice from "@apis/commonservice";
import { handleLanguageChange } from "@apis/hooks";
import { useAppSelector } from "@hooks/redux";
import { twMerge } from "tailwind-merge";
import { IconSelected } from "@icons/index";
import useLanguage from "@hooks/useLanguage";
import { broadcastManager } from "@hooks/broadcastManager";
import report from "@report";
const PopoverLanguageContent = ({ onClick }: { onClick: () => void }) => {
  const { languageOptions } = useAppSelector((state) => state.configReducer);
  const { isLogin } = useAppSelector((state) => state.globalReducer);
  const { language: nowLanguage, updateLanguage } = useLanguage();

  let languageOptionsArr = [...languageOptions];

  const changeLanguage = async (language: string) => {
    onClick?.();
    if (isLogin) {
      await commonservice.modifyProfile({
        language,
      });
      report.click({ kalo_pos: "modifyProfile", kalo_value: language, kalo_type: "language" });
    }
    updateLanguage(language);
    handleLanguageChange(language);
    broadcastManager.emit("refresh", { windowName: window._TAB_BROADCAST_MANAGER_NAME_ });
  };

  return (
    <div className="flex flex-col gap-px w-[260px] p-[8px] overflow-hidden max-h-[512px] overflow-y-auto">
      {languageOptionsArr.map((option) => {
        return (
          <div
            key={option.value}
            className={twMerge(
              "h-[38px] p-[8px] flex items-center text-kds-fg justify-between kalo-tag cursor-pointer",
              option.value === nowLanguage ? "kalo-tag-active" : "",
            )}
            onClick={() => {
              changeLanguage(option.value);
            }}
          >
            <div>{option.label}</div>
            {option.value === nowLanguage && <IconSelected></IconSelected>}
          </div>
        );
      })}
    </div>
  );
};

export default PopoverLanguageContent;
